import React, { useEffect, useMemo, useState } from "react";

// Add this hook to track container width
export const useContainerWidth = (ref: React.RefObject<HTMLDivElement>, triggerRecalc?: number) => {
	const [width, setWidth] = useState(0);

	useEffect(() => {
		if (!ref.current) return;

		const element = ref.current;

		const updateWidth = () => {
			setWidth(element.offsetWidth);
		};

		updateWidth();

		const resizeObserver = new ResizeObserver(updateWidth);
		resizeObserver.observe(element);

		return () => {
			resizeObserver.unobserve(element);
			resizeObserver.disconnect();
		};
	}, [ref, triggerRecalc]);

	return width;
};
